// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RejectPreviewOut = zod.object({
  "assets": zod.int(),
  "cases": zod.int(),
  "opportunities": zod.int()
});

export type RejectPreviewOut = zod.input<typeof RejectPreviewOut>;
export type RejectPreviewOutOutput = zod.output<typeof RejectPreviewOut>;
